import typeToReducer from "type-to-reducer";
import {
  GET_TRUS_OPERATORS_FAILURE,
  GET_TRUS_OPERATORS_PENDING,
  GET_TRUS_OPERATORS_SUCCESS,
} from "./types";

const trusOperatorsReducer = typeToReducer(
  {
    [GET_TRUS_OPERATORS_PENDING]: state => ({
      ...state,
      error: null,
      loading: true,
    }),
    [GET_TRUS_OPERATORS_SUCCESS]: (state, action) => ({
      ...state,
      error: null,
      operators: action.operators,
      loading: false,
    }),
    [GET_TRUS_OPERATORS_FAILURE]: (state, action) => ({
      ...state,
      error: action.error,
      loading: false,
    }),
  },
  {
    operators: null,
    loading: false,
    error: [],
  },
);

export default trusOperatorsReducer;
